import { getStorage } from '@/utils/storage';

// 字符串非空检测
export const required = (v: any) => !!v || '不能为空';

// 布尔类型的非空检测
export const boolRequired = (v?: boolean) => v != null || '不能为空';

// 数组类型的非空检测
export const listRequired = (v: any[]) => !!v && !!v.length || '不能为空';

// 手机号码检测. 必须以 1 开头，后面接 10 位数字
export const mobile = (v: string) => /^[1][\d]{10}$/.test(v) || '必须以1开头，后面跟10位任意数字';

// 邮箱检测
export const email = (v: string) => /^[\w\-.#]+@[\w\-.]+\.[\w-.]+$/.test(v) || '邮箱格式错误';

// 登录名称. 只允许数字，字母或_(选填)
export const loginName = (v: string) => !v || /^([a-zA-Z0-9_]+)$/.test(v) || '只能使用数字，字母或_';

// 真实姓名. 只允许2-8位汉字，字母或空格
export const realName = (v: string) => /^([\u4e00-\u9fa5]{2,8}|[a-zA-Z\s]+)$/.test(v) || '姓名格式错误';

// 限制指定字符长度(选填)
export const limit = (len: number) => (v: string) => !v || (v.length < (len + 1) || '长度超限');

// 整数(选填)
export const int = (v: string) => !v || /^[0-9]+$/.test(v) || '必须是整数';

// 数字(整数或浮点数, 选填)
export const num = (v: string) => !v || /^(-)?(0|[1-9]\d*)(\.\d+)?$/.test(v) || '非法的数字';

// 浮点数(整数或保留1-2位小数, 选填)
export const float = (v: string) => !v || /^(0|([1-9]\d*))(\.\d{1,2})?$/.test(v) || '必须是整数或小数点后保留1-2位的小数';

// 16进制颜色值检查(选填)
export const color = (v: string) => !v || /^#[a-fA-F\d]{6}$/.test(v) || '非法的颜色值';

// 百分比数字检查(整数不能超过100, 小数点保留1-3位)
export const percentage = (v: string) => /^(100|(0|[1-9]\d?)(\.\d{1,3})?)%$/.test(v) || '格式错误';

// 检测网络地址
export const urlReg = (v: string) => !v || /^(http).+$/.test(v) || '必须以 http 开头';

// 判断是否有权限
export const hasAuth = (moduleAuth: string[]): boolean => {
  const userAuth = JSON.parse(getStorage('userAuth') || '[]');
  const isAdmin = JSON.parse(getStorage('userInfo') || '{}').isSuperAdmin;
  return isAdmin || moduleAuth.some((authStr) => userAuth.indexOf(authStr) !== -1);
};

// 密码格式检查(非必填)
export const password = (v: string) => {
  if (!v) {
    return true;
  }
  if (!!v && v.length < 8) {
    return '密码长度不能小于8位';
  }
  if (/[^\w\d~!@#$%\^&*()\-_=+\[\]{}\\|/?,\.<>]+/.test(v)) {
    // 合法字符范围：~ ! @ # $ % ^ & * ( ) - _ = + [ ] { } \ | / ? , . < >
    return '包含非法字符';
  }
  let score = 0;
  const msg = '必须是8-20位大小写字母，数字，特殊字符中的3种。特殊字符范围如下：~!@#$%^&*()-=_+[]{}|/?,.<>';
  if (/\d+/.test(v)) {
    score += 1;
  }
  if (/[a-z]+/.test(v)) {
    score += 1;
  }
  if (/[A-Z]+/.test(v)) {
    score += 1;
  }
  if (/[~!@#$%\^&*()\-_=+\[\]{}\\|/?,\.<>]+/.test(v)) {
    score += 1;
  }
  return  score < 3 ? msg : true;
};
